(function ($) {
    if (typeof (epi) == 'undefined' || typeof (epi.EPiServer) == 'undefined' || typeof (epi.EPiServer.Forms) == 'undefined') {
        //console.error('EPiServer Forms was not properly initialized.');
        return;
    }
    if (typeof ($) == 'undefined') {
        //console.error('jQuery must be loaded for EPiServer Forms to work.');
        return;
    }

    // Replace the default error messages to include field name
    var customValidators = {

        Validators: {
            "EPiServer.Forms.Implementation.Validation.RequiredValidator": function (fieldName, fieldValue, validatorMetaData) {
                // summary:
                //      VALIDATE REQUIRED
                // fieldName: String
                //      Name of the field to be validated.
                // fieldValue: [Object]
                //      User input value for the field.
                // validatorMetaData: [Object]
                //      Validation meta data for the current element
                // returns: Object
                // tags:
                //      private

                // Check element's value for required field
                if (validatorMetaData) {

                    if (fieldValue == ""
                        // for FileUpload element
                        || (fieldValue && !fieldValue.length)) {

                        var msg = $.utils.formatString(
                            validatorMetaData.model.message,
                            $("[name=" + fieldName + "]")
                                .closest('div.Form__Element,fieldset.Form__Element')
                                .find('.Form__Element__Caption')
                                .contents()
                                .filter(function () { // Only get the text content, filter out any other elements
                                    return this.nodeType === 3;
                                }).text().toLowerCase()
                        );

                        return {
                            isValid: false,
                            message: msg
                        };
                    }
                }

                return { isValid: true };
            }
        }
    };

    $.extend(true, epi.EPiServer.Forms, customValidators);

    // Update aria-invalid attributes on validation
    $$epiforms(".EPiServerForms").on("elementValidated",
        function (e) {
            var formElement = $(e.element),
                input = formElement.find('[name="' + e.elementName + '"]'),
                elementToUpdate = formElement.hasClass("FormChoice") ? formElement : input,
                errorMsg = formElement.find(".Form__Element__ValidationError");

            console.log(e.elementName, formElement, input, errorMsg);

            if (!e.isValid) {
                elementToUpdate.addClass("input-validation-error").removeClass("input-validation-valid");
                elementToUpdate.attr("aria-invalid", true);
                errorMsg.addClass("field-validation-error").removeClass("field-validation-valid");
            } else {
                elementToUpdate.removeClass("input-validation-error").addClass("input-validation-valid");
                elementToUpdate.attr("aria-invalid", null);
                errorMsg.addClass("field-validation-valid").removeClass("field-validation-error");
            }
        })
        .on("formsStepValidating",
            function (e) {
                if (!e.isValid) {
                    var form = $(e.currentTarget),
                        alert = form.find(".alert"),
                        title = form.find(".Form__Title");

                    // Update the alert text to display the errors
                    var errorTexts = form.find(".Form__Element__ValidationError")
                        .map(function (index, el) {
                            return ({
                                id: el.id,
                                msg: el.innerText
                            });
                        });

                    var list = alert.find("ul");

                    // All items in error summary should be linked to the field containing errors
                    $.each(errorTexts, function () {
                        var formattedId = this.id.replace("-error-msg", "");

                        list.append('<li><a href="#' + formattedId + '">' + this.msg + '</a><li>');
                    });

                    alert.removeClass("hidden").focus();

                    // Scroll to top of form
                    title.get(0).scrollIntoView();
                }
            });

})(jQuery);